import common from '../modules/common.zh-CN'
import menu from '../modules/menu.zh-CN'
import field from '../modules/field.zh-CN'
import status from '../modules/status.zh-CN'
import type from '../modules/type.zh-CN'
import msg from '../modules/msg.zh-CN'
import placeholder from '../modules/placeholder.zh-CN'
import log from '../modules/log.zh-CN'
import dict from '../modules/dict.zh-CN'
import notification from '../modules/notification.zh-CN'
import dashboard from '../modules/dashboard.zh-CN'
import airline from '../modules/airline.zh-CN'
import role from '../modules/role.zh-CN'
import time from '../modules/time.zh-CN'
import feature from '../modules/feature.zh-CN'

export default {
  common,
  menu,
  field,
  status,
  type,
  unit: type.unit,
  msg,
  placeholder,
  log,
  dict,
  notification,
  dashboard,
  airline,
  role,
  time,
  feature,
}
